import {loadModalDialog} from 'static/modules/dialogs'
import {Controller} from 'stimulus'

export default class extends Controller {
  loadDialog(event) {
    loadModalDialog(event.params.url)
  }
}
